exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-file-append .input-group-text[data-v-748da206] {\n  height: 2.8125rem;\n}", ""]);

// exports
